import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import data from "../data";
import { useTranslation } from "react-i18next";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "react-bootstrap";
import classNames from "classnames";

function Navbar2() {
  const [click, setClick] = useState(false);
  const [isDropdownShown, setIsDropdownShown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("");

  const { t, i18n } = useTranslation();

  const handleChooseLan = (language) => {
    setSelectedLanguage(language);

    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
  };

  const languages = [
    ["🇬🇧 English", "en"],
    ["🇮🇩 Bahasa Indonesia", "id"],
    ["🇨🇳 中文", "zn"],
  ];

  const handleClick = () => setClick(!click);
  const toggleMobileDropdown = () => setIsDropdownShown(!isDropdownShown);

  const dropdownClass = classNames("dropdown", {
    "hide-dropdown": !isDropdownShown,
    "show-dropdown": isDropdownShown,
  });

  useEffect(() => {
    const currLan = localStorage.getItem("language");
    setSelectedLanguage(currLan);
  }, []);

  return (
    <>
      <nav className="navbar active">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo">
            <img
              className="navbar-logo"
              src={"images/anindya-logo.png"}
              alt="Anindya Logo"
            />
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i
              className={click ? "fas fa-times active" : "fas fa-bars active"}
            />
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            {Array.from(data.navpath, (e, i) => {
              return e.sub.length === 0 ? (
                <li className="nav-item">
                  <Link
                    key={i + 1}
                    to={e.path}
                    className={
                      window.location.pathname === data.navpath[i].path
                        ? "selected"
                        : "nav-links-fixed active"
                    }
                  >
                    {t(`navpath.${i}.name`, { returnObjects: true })}
                  </Link>
                </li>
              ) : (
                <>
                  <li className="nav-item-dd" key={i}>
                    <div
                      className={
                        window.location.pathname === e.path
                          ? "selected"
                          : "nav-links-dd active"
                      }
                      onClick={toggleMobileDropdown}
                    >
                      <Row>
                        {window.innerWidth <= 960 ? (
                          <div className="center">
                            {t(`navpath.${i}.name`, { returnObjects: true })}{" "}
                            <FontAwesomeIcon icon={faCaretDown} />
                          </div>
                        ) : (
                          <>
                            <Col md={8.5}>
                              {t(`navpath.${i}.name`, { returnObjects: true })}
                            </Col>
                            <Col md={1}>
                              <FontAwesomeIcon icon={faCaretDown} />
                            </Col>
                          </>
                        )}
                      </Row>
                    </div>
                    {e.sub && e.sub.length > 0 && (
                      <ul className={dropdownClass}>
                        {e.sub.map((sub, j) => (
                          <li key={j} className="sub-nav-item">
                            <Link
                              to={sub.path}
                              className={
                                window.location.pathname === sub.path
                                  ? "selected"
                                  : "nav-links-dd"
                              }
                            >
                              {t(`navpath.${i}.sub.${j}.name`, {
                                returnObjects: true,
                              })}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                </>
              );
            })}
            <select
              className="custom-select"
              onChange={(e) => handleChooseLan(e.target.value)}
              value={selectedLanguage}
            >
              {Array.from(languages, (lang, i) => {
                return <option value={lang[1]}>{lang[0]}</option>;
              })}
            </select>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar2;
